import React from 'react';
import { createStyles, withStyles, WithStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

import { SessionStateTestID, STATE_ATTRIBUTES } from './constants';

const styles = () =>
  createStyles({
    icon: {
      marginRight: 10,
      fontSize: 16,
    },
    sessionState: {
      width: 200,
    },
    state: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
  });

type Props = WithStyles<typeof styles> & {
  state: string;
};

const SessionState: React.FC<Props> = ({ classes, state }) => {
  const attributes = STATE_ATTRIBUTES[state];

  return (
    <div className={classes.sessionState} data-testid={SessionStateTestID}>
      <div className={classes.state}>
        <attributes.icon className={classes.icon} />

        <Typography>{attributes.text}</Typography>
      </div>
    </div>
  );
};

export default withStyles(styles)(SessionState);
